import { Injectable } from "@angular/core";

import { DataService } from "../shared/services/data.service";
import { ConfigurationService } from "../shared/services/configuration.service";

import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { RegionalSettingsDTO } from "../shared/dto-models/regionalSettingsDTO.model";
import { RegionalSettingsCommand } from "../shared/models/regionalSettingsCommand";

@Injectable()
export class RegionalSettingsService {
  private apiUrl = "";

  constructor(
    private service: DataService,
    private configurationService: ConfigurationService,
  ) {
    if (this.configurationService.isReady) {
      this.apiUrl = this.configurationService.serverSettings.userSettingsApiUrl;
    } else {
      this.configurationService.settingsLoaded$.subscribe(
        (x) => (this.apiUrl = x?.userSettingsApiUrl),
      );
    }
  }

  get(apiUrl?: string): Observable<RegionalSettingsDTO> {
    if (!this.apiUrl && !apiUrl) {
      return;
    }
    const ePermitsApiUrl = this.apiUrl ? this.apiUrl : apiUrl;
    const url = `${ePermitsApiUrl}/api/v1/regionalsettings`;

    return this.service.get(url).pipe(
      map((response: any) => {
        return response;
      }),
    );
  }

  save(command: RegionalSettingsCommand): Observable<true> {
    const url = `${this.apiUrl}/api/v1/regionalsettings/save`;

    return this.service.postWithId(url, command).pipe(
      map((response: any) => {
        return response;
      }),
    );
  }
}
